/*
 * @Description: 首页
 * @Version: 1.0
 * @Autor: huliekao
 * @Date: 2021-08-16 19:11:58
 * @LastEditors: Seven
 * @LastEditTime: 2021-09-06 17:56:51
 */
import Permissions from "./perm"
class WbHome extends Permissions {
  // 我的地盘
  static Homeone () {
    return WbHome.checkPerm('wb:biz:statisticsBiz')
  }
  //   筛选勤奋榜
  static Homeqinfen () {
    return WbHome.checkPerm('wb:ranking:diligent')
  }
    //   筛选动态榜
  static Homedongtai () {
    return WbHome.checkPerm('wb:ranking:dynamic')
  }
  // 联系情况分析
  static Homelianxi () {
    return WbHome.checkPerm('wb:biz:fllowStatistical')
  }
  // 我的消息
  static Homexiaoxi () {
    return WbHome.checkPerm('wb:biz:statimesaage')
  }
  // 呼叫动态
  static Homehujiao () {
    return WbHome.checkPerm('wb:callrecord:callStatistical')
  }
  // 通话
  static Hometonghua () {
    return WbHome.checkPerm('wb:callrecord:callTimeStatistical')
  }
  // 更多应用-招生道具
  static MoreAppZSDJ () {
    return WbHome.checkPerm('app:recruitment:tool')
  }
  // 更多应用-管理后台
  static MoreAppGLHT () {
    return WbHome.checkPerm('app:crm:admin')
  }
  // 更多应用-教务端
  static MoreAppJWD () {
    return WbHome.checkPerm('app:education:admin')
  }
  // 更多应用-讲师端
  static MoreAppJSD () {
    return WbHome.checkPerm('app:lecturer:admin')
  }
  // 更多应用-对账函
  static MoreAppDZH () {
    return WbHome.checkPerm('app:reconciliation:admin')
  }
  // 更多应用-机考税务师
  static MoreAppJKSWS () {
    return WbHome.checkPerm('app:tax:computer:test')
  }
}
export default WbHome
